var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _setup.props.dialogTitle,
        visible: _setup.props.visible,
        width: "70vw",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _setup.emit("update:visible", val),
        closed: _setup.handleClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(_setup.LanguageRadioButtons, {
            attrs: {
              value: _setup.currentLang,
              options: _setup.languageOptions,
            },
            on: { input: _setup.handleLangInput },
          }),
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _setup.localFormData,
                rules: _setup.formRules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "title" } },
                _vm._l(_setup.languageOptions, function (opt) {
                  return _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: opt.value === _setup.currentLang,
                        expression: "opt.value === currentLang",
                      },
                    ],
                    key: opt.value,
                    attrs: {
                      placeholder: "请输入公告标题（100个字符以内）",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _setup.localFormData.title[opt.value],
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData.title, opt.value, $$v)
                      },
                      expression: "localFormData.title[opt.value]",
                    },
                  })
                }),
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "内容", prop: "content" } },
                _vm._l(_setup.languageOptions, function (opt) {
                  return _setup.props.visible
                    ? _c(_setup.Tinymce, {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: opt.value === _setup.currentLang,
                            expression: "opt.value === currentLang",
                          },
                        ],
                        key: `notice-content-${opt.value}-${_setup.tinymceKey}`,
                        attrs: {
                          value: _setup.localFormData.content[opt.value],
                          height: 260,
                          language: "zh",
                        },
                        on: {
                          input: (val) =>
                            (_setup.localFormData.content[opt.value] = val),
                        },
                      })
                    : _vm._e()
                }),
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公告类型", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localFormData.type,
                        callback: function ($$v) {
                          _vm.$set(_setup.localFormData, "type", $$v)
                        },
                        expression: "localFormData.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("普通公告"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("特殊公告"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否弹窗显示", prop: "is_popup" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _setup.localFormData.is_popup,
                        callback: function ($$v) {
                          _vm.$set(_setup.localFormData, "is_popup", $$v)
                        },
                        expression: "localFormData.is_popup",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "展示配置" } }, [
                _c("div", { staticClass: "display-config" }, [
                  _c(
                    "div",
                    { staticClass: "config-row" },
                    [
                      _c(
                        "span",
                        { staticClass: "config-label" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "定时启用选项输入时间后才能生效，输入时间为空时，选项不会生效！",
                                placement: "top",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question config-icon",
                              }),
                            ]
                          ),
                          _vm._v(" 定时启用 "),
                        ],
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择启用时间（可选）",
                        },
                        on: { change: _setup.handleEnableAtChange },
                        model: {
                          value: _setup.localFormData.enable_at,
                          callback: function ($$v) {
                            _vm.$set(_setup.localFormData, "enable_at", $$v)
                          },
                          expression: "localFormData.enable_at",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "config-row" },
                    [
                      _c(
                        "span",
                        { staticClass: "config-label" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "定时停用选项输入时间后才能生效，输入时间为空时，选项不会生效！",
                                placement: "top",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question config-icon",
                              }),
                            ]
                          ),
                          _vm._v(" 定时停用 "),
                        ],
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择停用时间（可选）",
                        },
                        model: {
                          value: _setup.localFormData.disable_at,
                          callback: function ($$v) {
                            _vm.$set(_setup.localFormData, "disable_at", $$v)
                          },
                          expression: "localFormData.disable_at",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }